export const randomNumber = (min: number, max: number) => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const formatDecimal = (v: number | null | undefined): string =>
  v != null ? Number(v.toFixed(2)).toString() : '—';
